// @flow
import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { CSSTransitionGroup } from 'react-transition-group';
import Input from '../../components/Input';
import { convertValueToBoolean, FirstChild } from '../../helpers';
import { validatePhoneNumber } from '../../helpers';

type Value = {
  description: string,
  value: string
};

type Props = {
  isSaving: boolean,
  settings: {
    firstLogonIntroductoryInfoVideo: Value,
    registrationVideo: Value,
    supportPhoneNumber: Value,
    supportEmailAddress: Value,
    umStandardBookingEmailAddress: Value,
    umPremiumBookingEmailAddress: Value,
    umBookingFormHelpPdf: Value,
    amEncryptionKey: Value,
    selfRegistrationClosed: Value,
    dashboardAnnouncementText: Value
  },
  successMsg: string,
  errorMsg: string,
  handleSubmit: (v: Object) => void
};

const SettingsGeneralForm = ({
  handleSubmit,
  settings,
  isSaving,
  successMsg,
  errorMsg,
  ...props
}: Props) => (
  <Form onSubmit={handleSubmit}>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Dashboard Video URL"
          placeholder={
            settings && settings.firstLogonIntroductoryInfoVideo
              ? settings.firstLogonIntroductoryInfoVideo.description
              : ''
          }
          name="firstLogonIntroductoryInfoVideo.value"
        />
        <Field
          component={Input}
          type="text"
          label="Registration Video URL"
          placeholder={
            settings && settings.registrationVideo
              ? settings.registrationVideo.description
              : ''
          }
          name="registrationVideo.value"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="tel"
          label="Support Phone Number"
          placeholder={
            settings && settings.supportPhoneNumber
              ? settings.supportPhoneNumber.description
              : ''
          }
          name="supportPhoneNumber.value"
          validate={[validatePhoneNumber]}
        />
        <Field
          component={Input}
          type="email"
          label="Support Email"
          placeholder={
            settings && settings.supportEmailAddress
              ? settings.supportEmailAddress.description
              : ''
          }
          name="supportEmailAddress.value"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="email"
          label="UM Standard Booking Email Address"
          placeholder={
            settings && settings.umStandardBookingEmailAddress
              ? settings.umStandardBookingEmailAddress.description
              : ''
          }
          name="umStandardBookingEmailAddress.value"
        />
        <Field
          component={Input}
          type="email"
          label="UM Premium Booking Email Address"
          placeholder={
            settings && settings.umPremiumBookingEmailAddress
              ? settings.umPremiumBookingEmailAddress.description
              : ''
          }
          name="umPremiumBookingEmailAddress.value"
        />
        <Field
          component={Input}
          type="text"
          label="UM Booking Form Help PDF URL"
          placeholder={
            settings && settings.umBookingFormHelpPdf
              ? settings.umBookingFormHelpPdf.description
              : ''
          }
          name="umBookingFormHelpPdf.value"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="toggle"
          label="Addressed Mail Encryption Flag"
          name="amEncryptionFlag.value"
          format={convertValueToBoolean}
        />
        <Field
          component={Input}
          type="text"
          label="Addressed Mail Encryption Key"
          placeholder={
            settings && settings.amEncryptionKey
              ? settings.amEncryptionKey.description
              : ''
          }
          name="amEncryptionKey.value"
        />
        <Field
          component={Input}
          type="toggle"
          label="Self Registration Available"
          name="selfRegistrationAvailable.value"
          format={convertValueToBoolean}
        />
        <Field
          component={Input}
          type="text"
          label="Self Registration Closed URL"
          placeholder={
            settings && settings.selfRegistrationClosed
              ? settings.selfRegistrationClosed.description
              : ''
          }
          name="selfRegistrationClosed.value"
        />
        <Field
          component={Input}
          type="toggle"
          label="Show/Hide List Tab on Map Screen"
          name="showTargetList.value"
          format={convertValueToBoolean}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            settings && settings.dashboardAnnouncementText
              ? settings.dashboardAnnouncementText.description
              : ''
          }
          name="dashboardAnnouncementText.value"
          label="Dashboard Announcement Text"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12}>
        <Button
          bsStyle="primary"
          type="submit"
          className="relative-padding"
          disabled={isSaving}
        >
          {isSaving ? 'Saving...' : 'Save'}
        </Button>
      </Col>
    </Row>
    <br />
    <Row>
      <Col sm={12}>
        <CSSTransitionGroup
          component={FirstChild}
          transitionName="fade"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {successMsg ? (
            <p key="success" className="text-success">
              {successMsg}
            </p>
          ) : null}
        </CSSTransitionGroup>
      </Col>
    </Row>
    {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
  </Form>
);

export default reduxForm({
  form: 'settingsGeneralForm'
})(SettingsGeneralForm);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsGeneralForm.js